import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { ApiService } from '@app/utility/api.service';
import { UtilService } from '@app/utility/util.service';
import { timer } from 'rxjs/observable/timer'

declare var $: any, moment: any

@Component({
  selector: 'app-singlegatewaywait3',
  templateUrl: './singlegatewaywait3.component.html',
  styleUrls: ['./singlegatewaywait3.component.scss']
})
export class Singlegatewaywait3Component implements OnInit {


  _subscription: any

  PortalLogin: any

  isCompany = false
  isProcressSuccess = true

  ContactDros: any;
  telephoneOtp = ""
  otp = ""
  cookieData: any
  isCrisis = true
  PortalUser: any;
  Contact: any;
  abc2: any;
  abc: any;
  ref_id: string = ""
  citizenid: string = ""
  accessToken: any;
  dpa_portal: any = {}
  ContactData: any = {}

  timeLeft: number = 3600;
  message: string = ""

  constructor(private router: Router,
    private Util: UtilService,
    private Api: ApiService) {
  }

  ngOnInit() {
    let btn = document.querySelector('.btn');

    btn.addEventListener('click', function () {
      console.log("a")
    });
    //this.PortalUser = JSON.parse(localStorage.getItem("dpa_portal")); 
    //this.InvestigateAndAppealCondition(this.PortalUser.contactid);
    this.InvestigateAndAppealCondition(null);

    this.startTimer();
    this.startTimer2();

  }

  async InvestigateAndAppealCondition(UID: any) {
    let thisTs = this;
    //if (!this.Util.IsNullOrUndefined(UID)) {
    let drosWeb = ''
    let result: any = await this.Api.post("crmservice", "getUrlSingleGateway", { UID });
    if (!this.Util.IsNullOrUndefined(result)) {
      if (!this.Util.IsNullOrUndefined(result.authorizationUrl)) {
        console.log(result);
        drosWeb = result.authorizationUrl;
        localStorage.setItem("referenceId", result.referenceId)
        this.ref_id = result.referenceId;
        //this.citizenid = result.dpa_citizenid;
        this.accessToken = result.token;
        window.open(drosWeb, "_blank");
      }
      else {
        this.Util.WarningDialog("ไม่สามารถเชื่อมต่อกับระบบ Single GateWay ได้ กรุณาลองใหม่อีกครั้ง");
        thisTs.router.navigate(["mainmenu/index"]);
      }
    }
    else {
      this.Util.WarningDialog("ไม่สามารถเชื่อมต่อกับระบบ Single GateWay ได้ กรุณาลองใหม่อีกครั้ง");
      thisTs.router.navigate(["mainmenu/index"]);

    }
    // }
    //else  {
    //  this.Util.WarningDialog("ไม่สามารถเชื่อมต่อกับระบบ Single GateWay ได้ กรุณาลองใหม่อีกครั้ง");
    //  thisTs.router.navigate(["mainmenu/index"]);

    //}9f9998459f654734
  }


  async startTimer() {
    const source = timer(1000, 2000);
    this.abc = source.subscribe(val => {
      if (val < 3600) {
        this.message = this.dhms(this.timeLeft - val);
      }
      else {
        let thisTs = this;
        this.Util.WarningDialog("ท่านไม่ได้ทำรายการในเวลาที่กำหนด กรุณาเข้าระบบใหม่อีกครั้งหลังจากทำการยืนยันตัวตนเสร็จสิ้น");
        thisTs.router.navigate(["mainmenu/index"]);
      }
    });
  }

  async startTimer2() {
    const source2 = timer(3000, 6000);
    this.abc2 = source2.subscribe(val => {
      //this.ref_id = localStorage.getItem("referenceId");
      //this.ref_id = '9f9998459f654733';
      if (this.ref_id != "") {
        let para = "refId=" + this.ref_id + "&token=" + this.accessToken
        this.Api.get("crmservice", "GetDataSingleGatewayLog", para).then((ContactRes: any) => {
          console.log(ContactRes);
          this.ContactData = ContactRes;
          if (ContactRes.dpa_result !== undefined) {
            if (this.isProcressSuccess == ContactRes.procress) {
              if (ContactRes.dpa_result == 'Y') {
                if (ContactRes.dpa_contactid != null && ContactRes.dpa_contactid != "" && ContactRes.dpa_contactid != undefined) {
                  this.Login();
                } else {
                  let thisTs = this;
                  this.Util.ErrorDialog("ไม่พบข้อมูลการลงทะเบียนของท่าน  กรุณาติดต่อ DPA Call Center 1158");
                  thisTs.router.navigate(["/mainmenu/index"]);
                }
                //let thisTs = this;
                //this.Util.SuccessDialog("ท่านได้ทำการยืนยันตัวตนสำเร็จ");  
                //thisTs.router.navigate(["mainmenu/refundDeposits"]);
              }
              else if (ContactRes.dpa_result == 'R') {
                sessionStorage.setItem("dpa_portalThaiID", JSON.stringify(this.ContactData))
                this.router.navigate(["mainmenu/register"], { queryParams: { regisType: "n" } })
              }
              else if (ContactRes.dpa_result == 'N') {

                let thisTs = this;
                this.Util.ErrorDialog("ไม่พบข้อมูลการลงทะเบียนของท่าน  กรุณาติดต่อ DPA Call Center 1158");
                thisTs.router.navigate(["/mainmenu/index"]);
              }
              else if (ContactRes.dpa_result == 'CM') {

                let thisTs = this;
                this.Util.WarningDialog("ไม่สามารถเข้าสู่ระบบได้ เนื่องจากท่านยังไม่ได้ยืนยันการลงทะเบียนทางอีเมล");
                thisTs.router.navigate(["/mainmenu/index"]);
              }
              else {
                //let thisTs = this;
                //this.Util.ErrorDialog("ท่านทำการยืนยันตัวตนไม่สำเร็จ กรุณาทำการยืนยันตัวตนอีกครั้ง โดยใช้หมายเลขบัตรประชาชน หรือหมายเลขโทรศัพท์ที่ท่านได้ทำการลงทะเบียนไว้");  
                //thisTs.router.navigate(["mainmenu/refundDeposits"]);
              }
            }

          }
          //else{

          //  let thisTs = this;
          //  this.Util.ErrorDialog("ไม่พบข้อมูลการลงทะเบียนของท่าน  กรุณาติดต่อ DPA Call Center 1158");  
          //  thisTs.router.navigate(["/mainmenu/index"]);
          //}

        });

      }

      let btn = document.querySelector('.btn');
      let clickEvent = new Event('click');
      btn.dispatchEvent(clickEvent);

    });

  }

  dhms(t: number) {
    var minutes, seconds;
    minutes = Math.floor(t / 60) % 60;
    t -= minutes * 60;
    seconds = t % 60;
    return [
      minutes + ' นาที',
      seconds + ' วินาที'
    ].join(' ');
  }


  ngOnDestroy() {
    //prevent memory leak when component destroyed
    this.abc.unsubscribe();
    this.abc2.unsubscribe();
  }

  async getContactDROS(idcard: string) {
    let para = "dpa_id=" + idcard + "&telephoneno=&fullname=&CRM05=false&CRM04=false&CRM03=false&CRM02=false&CRM07=false"
    let tmp: any = await this.Api.get("crmservice", "contactDros", para)
    return tmp
  }

  async Login() {
    try {
      let contact: any = await this.Api.get("crmservice", "contact", "contactid=" + this.ContactData.dpa_contactid)
      contact = contact[0]
      console.log(contact)
      if (contact == null || contact == undefined) {
        sessionStorage.setItem("dpa_portalThaiID", JSON.stringify(this.ContactData))
        this.router.navigate(["mainmenu/register"], { queryParams: { regisType: "n" } })
      }


      this.dpa_portal = {
        firstname: contact.firstname,
        lastname: contact.lastname,
        email: contact.emailaddress1,
        contactid: this.ContactData.dpa_contactid,
        pid: contact.dpa_idcard,
        readNewsList: null
      }

      if (this.isCrisis) {
        if (contact.dpa_companytypeid != null && contact.dpa_companytypeid.trim().length > 0) {
          this.ContactDros = await this.getContactDROS(contact.dpa_registrationid)
        }
        else if (contact.dpa_passport != null && contact.dpa_passport.trim().length > 0) {
          this.ContactDros = await this.getContactDROS(contact.dpa_passport)
        }
        else {
          this.ContactDros = await this.getContactDROS(contact.dpa_idcard)
        }
        if (!this.Util.IsNullOrUndefined(this.ContactDros.CRM06)) {
          if (!this.Util.IsNullOrUndefined(this.ContactDros.CRM06.AccountStatus) && this.ContactDros.CRM06.AccountStatus == '2') {
            let thisTs = this;
            this.Util.WarningDialog("กรุณาติดต่อ DPA Call Center 1158");
            $("#btnWarningOK").click(function () {
              thisTs.router.navigate(["/mainmenu/index"]);
            });
            thisTs.router.navigate(["mainmenu/index"])
            return;
          }

          if (!this.Util.IsNullOrUndefined(this.ContactDros.CRM06.AccountStatus) && this.ContactDros.CRM06.AccountStatus == '3') {
            let thisTs = this;
            this.Util.WarningDialog("กรุณาติดต่อ DPA Call Center 1158");
            $("#btnWarningOK").click(function () {
              thisTs.router.navigate(["/mainmenu/index"]);
            });
            thisTs.router.navigate(["mainmenu/index"])
            return;
          }
        }

      }

      if (contact != null && contact.length > 0) {
        this.telephoneOtp = contact[0].telephone1
      }

      this.cookieData = this.dpa_portal
      localStorage.setItem("dpa_portal", JSON.stringify(this.dpa_portal))
      localStorage.setItem("verifyIdentity", "true")

      let ticket: any = await this.Api.get("crmservice", "searchApprovalTicket", "contactid=" + this.cookieData.contactid)
      this.Util.ShowWaiting(false)

      this.Util.SuccessDialog("ท่านได้ทำการยืนยันตัวตนสำเร็จ");
      let thisTs = this;
      $('#btnSuccessOK').on('click', function () {
        //thisTs.router.navigate(["mainmenu/index"])


        if (ticket != null && ticket.length > 0 && (ticket[0].dpa_approvalstatuscode == "01" || ticket[0].dpa_approvalstatuscode == "02" || ticket[0].dpa_approvalstatuscode == "06")) {
          let url = thisTs.Util.baseUrl() + "/mainmenu/statusDocument/" + thisTs.cookieData.contactid
          window.open(url, "_blank")
          //this.showLoginForm = false
          //this.showOtp = true
        }
        else {
          thisTs.Util.ShowWaiting(true)
          thisTs.router.navigate(["mainmenu/refundDeposits"])
        }
      });



    } catch (ex) {
      this.Util.ShowWaiting(false);
      console.log(ex)
      this.Util.ErrorDialog('เกิดข้อผิดพลาด กรุณาติดต่อเจ้าหน้าที่');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/singlegatewaywait3/singlegatewaywait3.component.ts